export enum ImpactAreas {
    AllImpactAreas = 'All impact areas',
    HumanHealth = 'Human Health',
    ClimateHealth = 'Climate Health',
    Circularity = 'Circular Economy',
    SocialHealthAndEquity = 'Social Health & Equity',
    EcosystemHealth = 'Ecosystem Health'
}
